<template lang="pug">
	#share-component.d-print-none(:class="{'more-open' : moreIsOpen}")
		.icon-container
			div
				a.icon.fb(:href="shareFacebookURL" target="_blank")
					span Facebook Share
			div
				a.icon.twitter(:href="shareTwitterURL"  target="_blank")
					span Twitter Share
			div
				a.icon.email(:href="mailToURL")
					svg(height='15', viewBox='0 0 21 15', width='21', xmlns='http://www.w3.org/2000/svg')
						g(fill='none', transform='translate(0 -1)')
							path(d='m19.1211429 15.99275h-17.31085719c-.83579514.0479594-1.58346089-.5234505-1.76838095-1.3515-.02775743-.1398564-.04040352-.2823644-.03771428-.425v-11.40275c-.02700801-.49637276.15890731-.98034769.50989591-1.32736148.3509886-.34701378.83276881-.52317298 1.32134218-.48313852h17.31085713c.4815521-.03866047.9561385.13526146 1.3020987.47718084.3459602.34191937.5296558.81859071.5039966 1.30781916v11.41975c.0195325.4920458-.1696688.9690127-.5197444 1.310249s-.8274956.5140588-1.3114937.474751z', fill='#fff')
							path(d='m18.4045714 4.675c.0502857-.051.1005715-.09775.1466667-.14875.2031031-.22070233.2702533-.53671709.1748104-.82267271-.095443-.28595563-.33805-.49562525-.6315723-.54582729-.3102238-.0626422-.6298111.04756095-.8380952.289l-6.1893334 6.086c-.1348314.19574139-.3554246.31235882-.5908571.31235882s-.4560258-.11661743-.59085717-.31235882l-6.11390476-6.01375c-.06500338-.06744877-.13354743-.13129155-.20533333-.19125-.22265899-.18918115-.52602583-.24794582-.80175722-.15530699-.27573139.09263882-.48450742.32347062-.55176659.61005699-.07136579.31607441.04079424.64579384.28914286.85l3.73790476 3.69325.176.17425-.18857143.19125-3.73371429 3.6635c-.22249703.1843677-.33636572.4714791-.30171428.76075.03720463.3188191.25801704.5845496.56152381.67575.3253699.1233786.69206102.0304037.92190476-.23375l3.77142857-3.6975.16761905-.15725c.46514286.476.92609524.92225 1.37866666 1.34725.38232972.4196225.9200803.6582367 1.4834286.6582367.5633482 0 1.1010988-.2386142 1.4834285-.6582367.456762-.425.9260953-.85 1.4499048-1.35575.0292535.06590103.0673263.12739673.1131429.18275 1.0029206.9916667 2.0100317 1.9833333 3.0213333 2.975.264.25925.528.527.800381.77775.2311727.2236016.5675742.2944748.8674285.18275.2952012-.0914973.511091-.3486052.5531429-.65875.0380399-.3025792-.0866971-.6026321-.3268572-.78625-1.2459682-1.2183333-2.4905396-2.4395-3.7337142-3.6635l-.1969524-.204c.076995-.05560587.1511243-.11518429.2220952-.1785z', fill='#21b163')
					span Email Share
			div
				a.icon.print(@click="printArticle();")
					svg(height='20', viewBox='0 0 18 20', width='18', xmlns='http://www.w3.org/2000/svg')
						path(d='m16.678 17.007h-.692v-5.628c0-.764-.62-1.383-1.385-1.383h-11.233c-.765 0-1.385.619-1.385 1.383v5.628h-.692c-.765 0-1.291-.619-1.291-1.385v-8.239c0-.766.62-1.386 1.385-1.386h15.23c.765 0 1.385.62 1.385 1.386v8.239c0 .766-.557 1.385-1.322 1.385zm-13.709-12.207v-3.20710322c0-.88008879.669-1.59289678 1.495-1.59289678h9.072c.826 0 1.495.71280799 1.495 1.59289678v3.20710322zm2.031 6.2h8c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-5c0-1.105.895-2 2-2zm0 6v1h4v-1zm0-2v1h7v-1zm0-2v1h7v-1z', fill='#fff', fill-rule='evenodd', transform='')

					span Print
			div.more-section
				div.icon(@click="moreIsOpen = !moreIsOpen")
					span.more
						span
						span
						span

		sfc-print-article-modal(:hero="hero")
		div(v-b-modal.print-article-modal ref="printModalTrigger")
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	#share-component
		width: 164px
		right: -7px
		position: relative
		height: 40px
		transition-all()
		overflow: hidden
		&.more-open
			width: 275px
		.more-section
			position: absolute
			right: 7px
			width: 46px!important
			padding-right: 0!important
			.icon
				border: 1px solid sfc-pale-gray
		.icon-container
			position: relative
			height: 40px
			overflow: hidden
			> div
				padding: 0 5px
				width: 55px
				display: inline-block
				float: left
				height: 40px
			.icon
				height: 40px
				width: 40px
				display: block
				background: #fff
				border-radius: 50%
				margin: 0 auto
				cursor: pointer
				text-align: center
				transition-all()
				> span
					opacity: 0
					&.more
						opacity: 1
						position: relative
						top: 9px
						> span
							height: 6px
							width: 6px
							background: sfc-pale-gray
							position: relative
							display: inline-block
							margin: 2px
							border-radius(50%)
							transition-all()
				&.fb
					background: url('https://web-resources.savingforcollege.com/images/social_icons/fb-icon.png') no-repeat
					background-size: 100%
					background-color: #fff
				&.twitter
					background: url('https://web-resources.savingforcollege.com/images/social_icons/twitter-icon.png') no-repeat
					background-size: 100%
				&.print
					background-color: sfc-yellow
					svg
						position: relative
						top: 7px
						width: 22px
				&.email
					background: rgb(33, 177, 99)
					svg
						position: relative
						top: 6px
						width: 22px
</style>
<script>
import SfcPrintArticleModal from '@/common/components/sfc-print-article-modal'

	export default {
		data(){
			return {
				moreIsOpen: false,			}
		},
		props: ['title', 'url', 'hero', 'hashtags', 'twitmention'],
		methods: {
			printArticle(){
				if (!this.$store.state.userIsLoggedIn && !this.$cookies.get('print_article_v2')){
					this.$refs.printModalTrigger.click()
				}else{
					window.print()
				}
			},
		},
		components:{
			SfcPrintArticleModal
		},
		created() {
			const currentUrl = encodeURIComponent(this.url)

			const currentTitle = encodeURIComponent(this.title)



			this.shareFacebookURL = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`
			this.shareTwitterURL = `https://twitter.com/share?url=${currentUrl}&text=${currentTitle}`
			if(this.hashtags){
				const currentHashtags = encodeURIComponent(this.hashtags)
				this.shareTwitterURL += `&hashtags=${currentHashtags}`;
			}
			if(this.twitmention){
				const currentVia = encodeURIComponent(this.twitmention)
				this.shareTwitterURL += `&via=${currentVia}`;
			}





			this.mailToURL = `mailto:?&subject=${this.title}&body=${currentUrl}`

		}
	}
</script>
